import React, { useState } from "react";
import Customization from "./Customization";
import CustomizationTwo from "./CustomizationTwo";
import {
  SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
  UPDATE_CART_FILTERED_MENU_ORDER,
} from "../../../../store/types";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { Modal, Button } from "react-bootstrap";
//import Customization2 from "./Customization2";

const AddButton = (props) => {
  // console.log(props.customizationData);
  const dispatch = useDispatch();

  const [repeatSizeModal, setRepeatSizeModal] = useState(false);
  const [showRepeatSize, setShowRepeatSize] = useState(false);
  const handleCloseRepeatSize = () => {
    setShowRepeatSize(false);
  };

  const handleClickYes = () => {
    incrementHandler();
    handleCloseRepeatSize();
  };

  const handleClickNo = () => {
    //setState({ ...state, cart: 0 });
    setRepeatSizeModal(true);
    handleCloseRepeatSize();
    setCustom(true);
  };

  const [custom, setCustom] = useState(false);

  const [state, setState] = useState({
    cart: 0,
  });
  const decrementHandler = (e) => {
    if (props.customizationData.cartLength - 1 !== 0) {
      let cartData = JSON.parse(JSON.stringify(props.cart_data));

      let getIndex = 0;
      for (let i = 0; i < props.cart_data.length; i++) {
        for (let j = 0; j < props.customizationData.size.length; j++) {
          if (
            props.cart_data[i][0].size._id ===
            props.customizationData.size[j]._id
          ) {
            getIndex = i;
            break;
          }
        }
      }
      let checkForZero = cartData[getIndex][0].quantity - 1;
      if (checkForZero === 0) {
        cartData.splice(getIndex, 1);
      } else {
        cartData[getIndex][0].quantity = cartData[getIndex][0].quantity - 1;
      }
      dispatch({
        type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
        payload: cartData,
      });
    }

    if (props.customizationData.cartLength - 1 === 0) {
      let cartData = JSON.parse(JSON.stringify(props.cart_data));

      let getIndex = 0;
      for (let i = 0; i < props.cart_data.length; i++) {
        for (let j = 0; j < props.customizationData.size.length; j++) {
          if (
            props.cart_data[i][0].size._id ===
            props.customizationData.size[j]._id
          ) {
            getIndex = i;
            break;
          }
        }
      }
      cartData.splice(getIndex, 1);
      dispatch({
        type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
        payload: cartData,
      });
    }
    if (state.count !== 0) {
      setState({ ...state, cart: state.cart - 1 });

      const formData = {};
      formData.cartLength = props.customizationData.cartLength - 1;
      formData.id = props.customizationData._id;

      dispatch({
        type: UPDATE_CART_FILTERED_MENU_ORDER,
        payload: formData,
      });
    }
  };

  const incrementHandlerForRepeatedSize = () => {
    setState({ ...state, cart: state.cart + 1 });
    const formData = {};
    formData.cartLength = props.customizationData.cartLength + 1;
    formData.id = props.customizationData._id;

    dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });
  };

  const incrementHandler = () => {
    setState({ ...state, cart: state.cart + 1 });

    const formData = {};
    formData.cartLength = props.customizationData.cartLength + 1;
    formData.id = props.customizationData._id;

    dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });

    if (props.customizationData.cartLength + 1 > 1) {
      let cartData = JSON.parse(JSON.stringify(props.cart_data));

      let getIndex = 0;
      for (let i = 0; i < props.cart_data.length; i++) {
        //      props.cart_data[i][0].size._id
        for (let j = 0; j < props.customizationData.size.length; j++) {
          if (
            props.cart_data[i][0].size._id ===
            props.customizationData.size[j]._id
          ) {
            getIndex = i;
            break;
          }
        }
      }
      cartData[getIndex][0].quantity = cartData[getIndex][0].quantity + 1;
      dispatch({
        type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
        payload: cartData,
      });
    }
  };

  const onClickContinue = (qty) => {
    const formData = {};
    formData.cartLength = qty;
    formData.id = props.customizationData._id;

    dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });
    setState({ ...state, cart: qty });
  };
  return (
    <>
      {props?.disabled ? (
        <>
          {" "}
          <button
            className="btn btn-secondary"
            disabled
            style={{ cursor: "no-drop" }}
          >
            Unavailable
          </button>
        </>
      ) : (
        <>
          {/* {state.cart === 0 ? ( */}
          {props.customizationData.cartLength === 0 ? (
            <Customization
              open={custom}
              setOpen={setCustom}
              onClickContinue={(qty) => onClickContinue(qty)}
              incrementHandler={(e) => incrementHandler(e)}
              customizationData={props.customizationData}
              orderSelected={props.orderSelected}
              categoryName={props.categoryName}
            />
          ) : (
            <div className="pl-md-2" align="center">
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="p-0 btn btn-link"
                  onClick={decrementHandler}
                >
                  <img
                    src={require("../../../../assets/images/superadmin/ordericon/less.svg")}
                    alt="Minus"
                    title="Minus"
                    className="img-fluid"
                    width="75px"
                  />
                </button>

                <input
                  placeholder="00"
                  //value={state.cart}
                  value={props.customizationData.cartLength}
                  className="enInputValueOnly f12-700"
                  width="30px"
                  onChange={() => {}}
                />
                <button
                  type="button"
                  className="p-0 btn btn-link"
                  //onClick={incrementHandler}
                  onClick={() =>
                    props.customizationData?.size.length <= 1
                      ? incrementHandler()
                      : setShowRepeatSize(true)
                  }
                >
                  <img
                    src={require("../../../../assets/images/superadmin/ordericon/add.svg")}
                    alt="add "
                    title="add"
                    className="img-fluid"
                    width="75px"
                  />
                </button>
              </div>
            </div>
          )}

          <CustomizationTwo
            // open={custom}
            onClickContinue={(qty) => onClickContinue(qty)}
            incrementHandlerForRepeatedSize={(e) =>
              incrementHandlerForRepeatedSize(e)
            }
            open={repeatSizeModal}
            customizationData={props.customizationData}
            orderSelected={props.orderSelected}
            categoryName={props.categoryName}
            closeCustom2={() => setRepeatSizeModal(false)}
          />

          <React.Fragment>
            <Modal
              show={showRepeatSize}
              onHide={handleCloseRepeatSize}
              centered
            >
              <Modal.Header className="py-0 pt-2 border-0" closeButton>
                <Modal.Title></Modal.Title>
              </Modal.Header>
              <Modal.Body className="f16-500">
                Do you want to repeat with same size ?
              </Modal.Body>
              <Modal.Footer className="justify-content-start border-0">
                <Button
                  variant="outline-secondary"
                  className="btn-lg mr-4 px-5"
                  onClick={() => handleClickNo()}
                  //onClick={handleCloseFlag}
                >
                  No
                </Button>
                <Button
                  variant="danger"
                  className="btn-lg px-5"
                  onClick={() => handleClickYes()}
                  //onClick={() => handleFlagUser(props.user._id, props.user.isFlag)}
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          </React.Fragment>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  cart_data: state.vendorOrdering.vendor_cart_data,
});

export default connect(mapStateToProps, null)(AddButton);
